import { Injectable } from '@angular/core';
import { I18NextPipe } from 'angular-i18next';
import { ThicknessLocationEvaluation } from '../../viewmodels/reports/thickness-reports/thickness-location-evaluation';

@Injectable()
export class ThicknessDisplayService {
  private readonly remainingLifeLimit = 100;
  private readonly remainingHalfLifeLimit = this.remainingLifeLimit / 2;

  public readonly noDataLabel = this.i18NextPipe.transform('ThicknessDisplayService.NoData');
  public readonly retirementDateTooltip = this.i18NextPipe.transform('ThicknessDisplayService.RetirementDateCalculatedBasedOnRemainingLife', {value:this.remainingLifeLimit});

  public readonly dueDateTooltip = this.i18NextPipe.transform('ThicknessDisplayService.DueDateCalculatedBasedOnRemainingHalfLifeWhichHasBeenLimited', {value:this.remainingHalfLifeLimit});

  constructor(
    private i18NextPipe: I18NextPipe
  ) {}

  createThicknessLabel(value: number, uomName: string): string {
    if (!uomName) {
      return '';
    }

    return `${this.createNumericLabel(value)}${uomName}`;
  }

  createNumericLabel(value: number): string {
    return value == null || isNaN(value) || !isFinite(value) ? '' : value.toFixed(5);
  }

  createPositiveNumericLabel(value: number): string {
    const positiveValue = this.convertNegativeValueToZero(value);

    return this.createNumericLabel(positiveValue);
  }

  createShortTermCorrosionRateLabel(thicknessLocationEvaluation: ThicknessLocationEvaluation): string {
    return this.createRateLabel(
      thicknessLocationEvaluation.shortTermCorrosionRate,
      thicknessLocationEvaluation.thicknessLocation.nominalThicknessUom.uomName,
    );
  }

  createAvgShortTermCorrosionRateLabel(thicknessLocationEvaluation: ThicknessLocationEvaluation): string {
    return this.createRateLabel(
      thicknessLocationEvaluation.avgShortTermCorrosionRate,
      thicknessLocationEvaluation.thicknessLocation.nominalThicknessUom.uomName,
    );
  }

  createAvgLongTermCorrosionRateLabel(thicknessLocationEvaluation: ThicknessLocationEvaluation): string {
    return this.createRateLabel(
      thicknessLocationEvaluation.avgLongTermCorrosionRate,
      thicknessLocationEvaluation.thicknessLocation.nominalThicknessUom.uomName,
    );
  }

  createLongTermCorrosionRateLabel(thicknessLocationEvaluation: ThicknessLocationEvaluation): string {
    return this.createRateLabel(
      thicknessLocationEvaluation.longTermCorrosionRate,
      thicknessLocationEvaluation.thicknessLocation.nominalThicknessUom.uomName,
    );
  }

  private createRateLabel(rate: number, uomName: string): string {
    if (rate == null) {
      return this.noDataLabel;
    }

    return this.createNumericLabel(rate) + uomName + this.i18NextPipe.transform('ThicknessDisplayService.PerYear');
  }

  private convertNegativeValueToZero(value: number): number {
    return value < 0 ? 0 : value;
  }
}
